import { useEffect } from 'react';
import { useFeatureFlags } from '../useFeatureFlags';

export function useSyncBoothTourElectronMenu() {
  const { isFeatureFlagEnabled: boothTourEnabled, isFetched } =
    useFeatureFlags('BOOTH_TOUR_ENABLED');

  useEffect(() => {
    if (!window.electronAPI?.menu?.setBoothTourEnabled) {
      return;
    }

    void window.electronAPI.menu.setBoothTourEnabled(
      isFetched ? boothTourEnabled : false,
    );

    return () => {
      void window.electronAPI?.menu?.setBoothTourEnabled(false);
    };
  }, [boothTourEnabled, isFetched]);
}
